<div class="modal-header">
	<h4 class="modal-title" translate>
		<i class="fa fa-ban text-danger"></i> {{ 'Limit Reached for This Feature' | translate }}
	</h4>
	<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close(false)"></button>
</div>
<div class="modal-body">
	<p>
		{{ errorMessage }}
	</p>
	<div class="col-md-12 text-center">
		<button type="button" class="btn btn-secondary text-center" (click)="upgrade()">
			<span><i class="fa fa-rocket me-2"></i></span>{{ 'Upgrade' | translate }}
		</button>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-light" (click)="activeModal.close(false)">{{ 'Cancel' | translate }}</button>
</div>
